import { Box, Button, Grid, Stack, TextField, Typography } from "@mui/material";
import FastRewindIcon from "@mui/icons-material/FastRewind";
import SaveIcon from "@mui/icons-material/Save";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import React, { useState } from "react";
import { LoadingButton } from "@mui/lab";
import Modal from "../../../components/modal/modal";

const FooterReport = ({
  loadDraft,
  handleSubmit,
  handleDraft,
  handleExport,
  printOnly = false,
  readOnly = false,
  createdDoc = "",
  newDoc = true,
  newDocLapInvest = false,
  handleReject = false,
  isRejectButton = false,
  handleRejectFunction,
  setReason,
  reason
}) => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xl={6} lg={6} sm={6} xs={12}></Grid>
        {/* <Grid item xl={6} lg={6} sm={6} xs={12}>
          <Stack spacing={2}>
            <div style={{ textAlign: "right" }}>
              <Typography variant="caption">Dilaporkan oleh:</Typography>
              <Typography variant="body1">
                <b>Executive GM Region / VP</b>
              </Typography>
            </div>
          </Stack>
        </Grid> */}
      </Grid>
      <br />
      <br />
      <br />
      <br />
      <Grid textAlign={"center"}>
        <Typography variant="body1">
          <b>{createdDoc}</b>
        </Typography>
        <Typography variant="subtitle1">
          {new Date()
            .toLocaleDateString("en-GB", {
              day: "numeric",
              month: "long",
              year: "numeric",
            })
            .toString()}
        </Typography>
      </Grid>

      <br />
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        style={{ minHeight: "10vh" }}
      >
        <Grid item xs={3}>
          <Stack spacing={2} direction="row">
            {!newDoc ? (
              <>
                <Button
                  variant="contained"
                  sx={{ width: "170px" }}
                  onClick={handleExport}
                  startIcon={<FileDownloadIcon />}
                >
                  Print
                </Button>
              </>
            ) : null}

            {!printOnly ? (
              <>
                <LoadingButton
                  onClick={handleDraft}
                  autoFocus
                  variant="outlined"
                  // loading={loadDraft}
                  startIcon={<SaveIcon />}
                  loadingPosition="start"
                  sx={{ width: "170px" }}
                  disabled={readOnly}
                >
                  Save As Draft
                </LoadingButton>
                {!newDocLapInvest ? (
                  <>
                    <Button
                      variant="contained"
                      sx={{ width: "150px" }}
                      type="submit"
                      onClick={() => handleSubmit()}
                      disabled={readOnly}
                    >
                      SUBMIT
                    </Button>
                  </>
                ) : null}
              </>
            ) : null}

            {isRejectButton && (
              <LoadingButton
                onClick={() => setIsOpen(true)}
                autoFocus
                variant="outlined"
                // loading={loadDraft}
                sx={{ width: "170px" }}
                disabled={readOnly}
              >
                Reject
              </LoadingButton>
            )}
          </Stack>
        </Grid>
      </Grid>
      <a href="/hsse/incident/dashboardlkp" style={{ textDecoration: "none" }}>
        <Button
          variant="text"
          startIcon={<FastRewindIcon />}
          sx={{ color: "black" }}
        >
          Back
        </Button>
      </a>

      <Modal
        open={isOpen}
        onClose={setIsOpen}
        title='Notifikasi'
        content={
          <>
            <div>Apakah and yakin akan Me-Reject dokument ini?</div>
            <div>Jika iya, maka dokumen akan kembali menjadi Draft, dan dapat di edit</div>
            <div>kembali oleh pembuat dokumen</div>
            <div style={{ fontSize: "20px" }}>
              <b>Alasan</b>
            </div>
            <TextField
              id="outlined-multiline-flexible"
              multiline
              rows={4}
              fullWidth
              onChange={(event) => setReason && setReason(event.target.value)}
              value={reason}
            />
          </>
        }
        actions={
          <>
            <Button
              color="error"
              autoFocus
              variant="outlined"
              onClick={() => setIsOpen(false)}
            >
              <span>Batal</span>
            </Button>
            <LoadingButton
                onClick={() => {
                  handleRejectFunction && handleRejectFunction()
                  setIsOpen(false)
                }}
                autoFocus
                variant="outlined"
                // loading={loadDraft}
                startIcon={<SaveIcon />}
                loadingPosition="start"
                sx={{ width: "150px" }}
            >
              Ya Reject
            </LoadingButton>
          </>
        }
      />
    </div>
  );
};

export default FooterReport;
